module.exports = __webpack_public_path__ + "img/p_21.336af003.png";